import { Fragment } from 'react';

import useClubHeader from './UseClubHeader';

import NavLinks from '../../views/club/NavLinks';

import CanvasImage from '../canvasImage/CanvasImage';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import ExclamationIcon from '@usas/ui-web/components/icons/ExclamationIcon';
import IsInGoodStandingIcon from '@usas/ui-web/components/icons/InGoodStandingIcon';
import LargeContextBasedNav from '@usas/ui-web/components/contextBasedNav/LargeContextBasedNav';
import MobileContextBasedNav from '@usas/ui-web/components/contextBasedNav/MobileContextBasedNav';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import { getConfig } from '@usas/ui-web/config/RuntimeConfig';

const ClubHeader = ({ children }) => {
  const {
    xCoord,
    isSSRPCurrent,
    clubHeadCoach,
    logoOverlayText,
    backToSelectionText,
    clubNotInGoodStandingReasons,
    state,
    clubBaseInfoState,
    selectOrgUnitState,
    onBackClicked
  } = useClubHeader();

  const Logo = () => {
    return (
      <div style={{ fontSize: 18 }}>
        <CanvasImage image={`${getConfig().VITE_CDN_URL}/SafeSportVerifiedLogo_200.png`} textToOverlay={logoOverlayText} xLoc={xCoord} yLoc={114} fontName={'oswald'} fontSize={16} />
      </div>
    );
  }

  return (
    <Fragment>
      {selectOrgUnitState.showBackToSelection === true && state.backToSystemLabel === backToSelectionText &&
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackClicked}>
              <LeftArrowIcon />  {state.backToSystemLabel}
            </button>
          </div>
        </div>}
      {state.backToSystemLabel !== backToSelectionText &&
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackClicked}>
              <LeftArrowIcon />  {state.backToSystemLabel}
            </button>
          </div>
        </div>}
      <div className="row">
        <div className="col-xs-12 col-lg-6">
          <p className={global.HeaderText}><strong>LSC:</strong>&nbsp;{clubBaseInfoState.objData.parentOrgUnitCode || ''}</p>
          <p className={global.HeaderText}><strong>Club Code:</strong>&nbsp;{clubBaseInfoState.objData.orgUnitCode || ''}</p>
          <p className={global.HeaderText}><strong>Club Name:</strong>&nbsp;{clubBaseInfoState.objData.orgUnitName || ''}</p>
          <p className={global.HeaderText}><strong>Club Head Coach:</strong>&nbsp;{clubHeadCoach || 'No Head Coach Assigned'}</p>
          <p className={global.HeaderText}><strong>Club in Good Standing?</strong> {clubBaseInfoState.objData.isInGoodStanding === true
            ? <span style={{ color: '#b1953a' }}><IsInGoodStandingIcon /></span>
            : <span><ExclamationIcon /> {clubNotInGoodStandingReasons}</span>}</p>
        </div>
        <div className="col-lg-6">
          {clubBaseInfoState.isObjLoading === false && isSSRPCurrent && <Logo />}
        </div>
      </div>
      <div id='context-nav' className="row">
        <div className="visible-xs col-xs-12">
          <MobileContextBasedNav taxonomyName="ClubDetail" />
        </div>
        <div className="hidden-xs col-xs-12">
          <LargeContextBasedNav taxonomyName="ClubDetail" homeRoute={NavLinks.CLUB_INFO} />
        </div>
      </div>
      {children}
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={clubBaseInfoState.isObjLoading} />
    </Fragment>
  );
};

export default ClubHeader;